// import 'polyfills'
import "whatwg-fetch";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./app/store";
import App from "./app/App";
import "./locales/i18n";
import { Buffer } from 'buffer';
window.Buffer = Buffer;
window.onunload = function (){ 
 //	sessionStorage.clear();
}
function render() {
  
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById("root")
  );
}

render();

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./app/App", render);
}
